var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { domainService } from "~/config/server";
import { NetService } from "~/utils/net.service";
import { Inject, Debounce } from "~/core/decorator";
import { Service } from "~/core/service";
var CaseOperatorPageService = /** @class */ (function (_super) {
    __extends(CaseOperatorPageService, _super);
    function CaseOperatorPageService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * 新增地址
     * @param data
     */
    CaseOperatorPageService.prototype.repairPersonalContact = function (data) {
        var reqData = __assign({}, data);
        delete reqData.areaIds;
        return this.netService.send({
            server: domainService.caseOperatorPageController.repairPersonalContact,
            data: reqData
        });
    };
    /**
     * 查询外访附件
     */
    CaseOperatorPageService.prototype.queryVisitAttachment = function (data) {
        return this.netService.send({
            server: domainService.caseOperatorPageController.queryVisitAttachment,
            data: {
                followRecordId: data
            }
        });
    };
    /**
     * 分页查询跟进
     */
    CaseOperatorPageService.prototype.caseFollowupRecord = function (data, page, sort) {
        return this.netService.send({
            server: domainService.caseOperatorPageController.caseFollowupRecord,
            data: data,
            page: page,
            sort: sort
        });
    };
    /**
     * 电话录音查询列表
     */
    CaseOperatorPageService.prototype.caseTelRecord = function (data, page, sort) {
        return this.netService.send({
            server: domainService.caseOperatorPageController.caseTelRecord,
            data: data,
            page: page,
            sort: sort
        });
    };
    /**
     * 增加催收总结
     */
    CaseOperatorPageService.prototype.addCaseTelRecord = function (data) {
        return this.netService.send({
            server: domainService.caseOperatorPageController.addCaseTelRecord,
            data: data
        });
    };
    /**
     * 客户开户信息查询
     */
    CaseOperatorPageService.prototype.personalBankInfo = function (caseId) {
        return this.netService.send({
            server: domainService.caseOperatorPageController.personalBankInfo,
            data: {
                caseId: caseId
            }
        });
    };
    /**
     * 客户联系人信息查询
     */
    CaseOperatorPageService.prototype.personalContacts = function (caseId) {
        return this.netService.send({
            server: domainService.caseOperatorPageController.personalContacts,
            data: {
                caseId: caseId
            }
        });
    };
    /**
     * 客户信息查询
     */
    CaseOperatorPageService.prototype.personalInfo = function (caseId) {
        return this.netService.send({
            server: domainService.caseOperatorPageController.personalInfo,
            data: {
                caseId: caseId
            }
        });
    };
    /**
     * 执行页顶部信息
     */
    CaseOperatorPageService.prototype.topInfo = function (data) {
        return this.netService.send({
            server: domainService.caseOperatorPageController.topInfo,
            data: {
                caseId: data
            }
        });
    };
    /**
     * 客户房产信息
     */
    CaseOperatorPageService.prototype.queryPersonalHouse = function (caseId) {
        return this.netService.send({
            server: domainService.caseOperatorPageController.queryPersonalHouse,
            data: {
                caseId: caseId
            }
        });
    };
    /**
     * 客户收支状况查询
     */
    CaseOperatorPageService.prototype.queryPersonalIncome = function (caseId) {
        return this.netService.send({
            server: domainService.caseOperatorPageController.queryPersonalIncome,
            data: {
                caseId: caseId
            }
        });
    };
    /**
     * 产品信息查询
     */
    CaseOperatorPageService.prototype.queryProduct = function (caseId) {
        return this.netService.send({
            server: domainService.caseOperatorPageController.queryProduct,
            data: {
                caseId: caseId
            }
        });
    };
    /**
     * 产品信息查询
     */
    CaseOperatorPageService.prototype.queryCaseInfo = function (caseId) {
        return this.netService.send({
            server: domainService.caseOperatorPageController.queryCaseInfo,
            data: {
                caseId: caseId
            }
        });
    };
    /**
     * 共债信息查询
     */
    CaseOperatorPageService.prototype.queryDebtCaseInfo = function (data, page, sort) {
        return this.netService.send({
            server: domainService.caseOperatorPageController.queryDebtCaseInfo,
            data: data,
            page: page,
            sort: sort
        });
    };
    /**
     * 案件批注分页查询
     */
    CaseOperatorPageService.prototype.caseRemark = function (data, page, sort) {
        return this.netService.send({
            server: domainService.caseOperatorPageController.caseRemark,
            data: data,
            page: page,
            sort: sort
        });
    };
    /**
     * 添加案件批注
     */
    CaseOperatorPageService.prototype.addCaseRemark = function (data) {
        return this.netService.send({
            server: domainService.caseOperatorPageController.addCaseRemark,
            data: data
        });
    };
    /**
     * 客户联系人地址信息查询
     */
    CaseOperatorPageService.prototype.queryPersonalAddress = function (data, page, sort) {
        return this.netService.send({
            server: domainService.caseOperatorPageController.queryPersonalAddress,
            data: data,
            page: page,
            sort: sort
        });
    };
    /**
     * 增加催收跟进
     */
    CaseOperatorPageService.prototype.addCaseFollowupRecord = function (append, data) {
        return this.netService.send({
            server: domainService.caseOperatorPageController.addCaseFollowupRecord,
            append: append,
            data: data
        });
    };
    /**
     * 查询催收总结
     */
    CaseOperatorPageService.prototype.findCaseTelRecord = function (data, page) {
        return this.netService.send({
            server: domainService.caseOperatorPageController.findCaseTelRecord,
            data: data,
            page: page
        });
    };
    /**
     * 申请历史
     */
    CaseOperatorPageService.prototype.caseApplyHistory = function (data, page) {
        return this.netService.send({
            server: domainService.caseOperatorPageController.caseApplyHistory,
            data: data,
            page: page
        });
    };
    /**
     * 催收执行页面--通讯录--添加联系人
     * @param data
     * @param loading
     */
    CaseOperatorPageService.prototype.addPersonalContact = function (data) {
        return this.netService.send({
            server: domainService.caseOperatorPageController.addPersonalContact,
            data: data,
            loading: true
        });
    };
    /**
     * 催收执行页面--通讯录--删除联系人
     * @param data
     */
    CaseOperatorPageService.prototype.deletePersonalContact = function (personalId) {
        return this.netService.send({
            server: domainService.caseOperatorPageController.deletePersonalContact,
            data: {
                id: personalId
            },
            loading: true
        });
    };
    /**
     * 催收执行页面--行动区--流转历史
     * @param data
     */
    CaseOperatorPageService.prototype.getAllCaseTurnRecords = function (data, page) {
        return this.netService.send({
            server: domainService.caseOperatorPageController.getAllCaseTurnRecords,
            data: data,
            page: page
        });
    };
    /**
     * 催收执行页面--发送短信
     * @param data
     * @param loading
     */
    CaseOperatorPageService.prototype.sendMessage = function (data) {
        return this.netService.send({
            server: domainService.caseOperatorPageController.sendMessage,
            data: data,
            loading: true
        });
    };
    /**
     * 催收执行页面--发送邮件
     * @param data
     * @param loading
     */
    CaseOperatorPageService.prototype.sendMail = function (data) {
        return this.netService.send({
            server: domainService.caseOperatorPageController.sendMail,
            data: data,
            loading: true
        });
    };
    /**
     * 催收执行页面--发送短信--获取短信内容
     * @param data
     * @param loading
     */
    CaseOperatorPageService.prototype.getTemplateContent = function (data) {
        return this.netService.send({
            server: domainService.caseOperatorPageController.getTemplateContent,
            data: data
        });
    };
    /**
     * 催收执行页--还款计划
     */
    CaseOperatorPageService.prototype.queryRepaymentPlan = function (data, page) {
        return this.netService.send({
            server: domainService.caseOperatorPageController.queryRepaymentPlan,
            data: {
                caseId: data
            },
            page: page
        });
    };
    /**
     * 催收执行页--附件信息
     */
    CaseOperatorPageService.prototype.queryCaseUploadFile = function (data, page, sort) {
        return this.netService.send({
            server: domainService.caseOperatorPageController.queryCaseUploadFile,
            data: {
                caseId: data
            },
            page: page,
            sort: sort
        });
    };
    /**
     * 更改风险客户标识
     */
    CaseOperatorPageService.prototype.modifyRiskFlag = function (data) {
        return this.netService.send({
            server: domainService.caseOperatorPageController.modifyRiskFlag,
            data: {
                caseId: data
            },
        });
    };
    /**
     * 外放总结获取联系人信息
     */
    CaseOperatorPageService.prototype.getPersonalContactInfo = function (data) {
        return this.netService.send({
            server: domainService.caseOperatorPageController.getPersonalContactInfo,
            data: data,
        });
    };
    /**
     * 增加法务催收跟进
     */
    CaseOperatorPageService.prototype.addCaseLegalRecord = function (data) {
        return this.netService.send({
            server: domainService.caseOperatorPageController.addCaseLegalRecord,
            data: data,
        });
    };
    /**
     * 分页查询法务跟进
     */
    CaseOperatorPageService.prototype.queryCaseLegalRecord = function (data, page, sort) {
        return this.netService.send({
            server: domainService.caseOperatorPageController.queryCaseLegalRecord,
            data: data,
            page: page,
            sort: sort,
        });
    };
    /**
     * 查询最新的未结案的法催记录
     */
    CaseOperatorPageService.prototype.queryUnClossCaseLegalRecord = function (data) {
        return this.netService.send({
            server: domainService.caseOperatorPageController.queryUnClossCaseLegalRecord,
            data: {
                caseId: data
            }
        });
    };
    /**
     * 通过id查询法催记录
     */
    CaseOperatorPageService.prototype.queryCaseLegalRecordById = function (data) {
        return this.netService.send({
            server: domainService.caseOperatorPageController.queryCaseLegalRecordById,
            data: {
                id: data
            }
        });
    };
    /**
     * 查询执行立案法院名称去重
     */
    CaseOperatorPageService.prototype.queryExecuteCourtName = function () {
        return this.netService.send({
            server: domainService.caseOperatorPageController.queryExecuteCourtName
        });
    };
    CaseOperatorPageService.prototype.queryWarehouseChangeRecords = function (data, page) {
        return this.netService.send({
            server: domainService.caseOperatorPageController.queryWarehouseChangeRecords,
            data: data,
            page: page
        });
    };
    /**
     * 单个附件删除
     */
    CaseOperatorPageService.prototype.deleteCaseUploadFileById = function (fileId) {
        return this.netService.send({
            server: domainService.caseOperatorPageController.deleteCaseUploadFileById,
            data: {
                fileId: fileId
            }
        });
    };
    CaseOperatorPageService.prototype.getCaseInfoRecordIdById = function (caseInfoRecordId) {
        return this.netService.send({
            server: domainService.caseOperatorPageController.getCaseInfoRecordIdById,
            data: {
                caseInfoRecordId: caseInfoRecordId
            }
        });
    };
    __decorate([
        Inject(NetService)
    ], CaseOperatorPageService.prototype, "netService", void 0);
    __decorate([
        Debounce()
    ], CaseOperatorPageService.prototype, "personalContacts", null);
    __decorate([
        Debounce()
    ], CaseOperatorPageService.prototype, "topInfo", null);
    __decorate([
        Debounce()
    ], CaseOperatorPageService.prototype, "addPersonalContact", null);
    __decorate([
        Debounce()
    ], CaseOperatorPageService.prototype, "deletePersonalContact", null);
    __decorate([
        Debounce()
    ], CaseOperatorPageService.prototype, "sendMessage", null);
    __decorate([
        Debounce()
    ], CaseOperatorPageService.prototype, "sendMail", null);
    __decorate([
        Debounce()
    ], CaseOperatorPageService.prototype, "getTemplateContent", null);
    __decorate([
        Debounce()
    ], CaseOperatorPageService.prototype, "queryRepaymentPlan", null);
    __decorate([
        Debounce()
    ], CaseOperatorPageService.prototype, "queryCaseUploadFile", null);
    __decorate([
        Debounce()
    ], CaseOperatorPageService.prototype, "queryUnClossCaseLegalRecord", null);
    __decorate([
        Debounce()
    ], CaseOperatorPageService.prototype, "queryCaseLegalRecordById", null);
    __decorate([
        Debounce()
    ], CaseOperatorPageService.prototype, "queryExecuteCourtName", null);
    return CaseOperatorPageService;
}(Service));
export { CaseOperatorPageService };
